module.exports = __webpack_public_path__ + "img/iatalogo.2b77ad9e.webp";